import React, { Component } from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ProgressIndicator } from 'office-ui-fabric-react/lib/ProgressIndicator';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

import XHRUploader from 'react-xhr-uploader';
import Cookies from "universal-cookie";

import HttpService from '../service/HttpService';
import Header from '../component/Header';
import ImportPolicies from '../component/ImportPolicies';

export default class Policies extends React.Component {
  http = new HttpService();
  loader = null;
  lo = require( 'lodash' );
  toPost = {};
  
  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( !session ) {
      window.location.href = '/auth';
    }

    this.state = {
      viewOpen: false,
      showPanel: false,
      activeItem: {},
      items: [],
      clients: [],
      showDocuments: false,
      importOpen: false,
      documents: []
    };
  }

  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando pólizas...' );
    
    this.http
      .getPolicies()
      .then( policies => {
        this.setState({ items: policies });

        if( this.props.match.params.id !== undefined ) {
          this.filter( this.props.match.params.id );
        }

        loader.loading( 'Cargando clientes...' );

        this.http
          .getClients()
          .then( clients => {
            this.setState({ clients: clients });

            loader.loading( 'Cargando empresas aseguradoras...' );

            this.http
              .getCompanies()
              .then( companies => {
                this.setState({ companies: companies });

                loader.loading( 'Cargando tipos de pólizas...' );

                this.http
                  .getTypes()
                  .then( types => {
                    this.setState({ types: types });

                    loader.finish();
                  })
                  .catch( this.errorHandler );
              })
              .catch( this.errorHandler );
          })
          .catch( this.errorHandler );
      })
      .catch( this.errorHandler );
  }

  errorHandler = ( error ) => {
    this.refs.header.loader().finish();

    this.refs.header.dialog().show( error );
  }

  export = () => {
    console.log( this.state.items );
    
    let exportData = [ '#', 'Nombre', 'Teléfono', 'Email', 'DNI / CUIT', 'Compañia', 'Tipo', 'Número de póliza', 'Inicio cobertura', 'Fin cobertura', 'Referencia' ].join( ',' ) + '\r\n';

    this.state.items.forEach( ( item, index ) => {
      let client = this.getClientData( item.client );
      let row = [ 
        client.id, client.name, client.phone, client.email, client.documentNumber, 
        item.company_name, item.type_name, item.policy_number, item.coverage_start, item.coverage_end, item.reference 
      ];

      exportData = exportData + row.join( ',' ) + '\r\n';
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI( exportData );
    hiddenElement.target = '_blank';
    hiddenElement.download = 'report.csv';
    hiddenElement.click();
  }

  selectedItemChange = ( item ) => {
    this.setState({
      viewOpen: item
    });
  }

  newItemHandler = () => {
    this.setState({
      showPanel: true,
      activeItem: { }
    })
  }

  editItemHandler = () => {
    if( this.state.viewOpen !== false ) {
      this.setState({
        showPanel: true,
        activeItem: this.state.viewOpen
      })

      this.toPost = this.lo.cloneDeep( this.state.viewOpen );
    } else {
      this.setState({ activeItem: {} });

      this.errorHandler( 'Debe seleccionar una póliza para editar' );
    }
  }

  deleteItemHandler = () => {
    if( this.state.viewOpen !== false ) {

      let loader = this.refs.header.loader().loading( 'Guardando cambios...' );
      
      this.http
        .deletePolicy( this.state.viewOpen.id )
        .then( ( policies ) => {
          this.toPost = null;

          this.setState({ items: policies, activeItem: {}, viewOpen: false });

          if( this.props.match.params.id !== undefined ) {
            this.filter( this.props.match.params.id );
          }

          loader.finish();
        })
    } else {
      this.errorHandler( 'Debe seleccionar una póliza para eliminar' );
    }
  }

  saveItemHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .savePolicy( this.toPost )
      .then( ( policies ) => {
        this.toPost = null;

        this.setState({ items: policies, activeItem: {}, viewOpen: false });

        if( this.props.match.params.id !== undefined ) {
          this.filter( this.props.match.params.id );
        }
        
        loader.finish();
      })
      .catch( this.errorHandler );

    this.setState({ showPanel: false });
  }

  showDocuments = () => {
    if( this.state.viewOpen !== false ) {
      this.http
        .getAttachmentForPolicy( this.state.viewOpen.id )
        .then( ( documents ) => {
          this.setState({ showDocuments: true, progress: true })
          this.setState({ progress: false, documents: documents });
        })
        .catch( this.errorHandler );
    } else {
      this.errorHandler( 'Debe seleccionar una póliza para ver los documentos asociados' );
    }
  }

  updateItem = ( item, name = null ) => {
    if( name !== null) {
      this.toPost[name] = item;
    } else {
      this.toPost[item.target.name] = item.target.value;
    }
  }

  getClientData = ( id ) => {
    for( var i=0; i<this.state.clients.length; i++ ) {
      if( this.state.clients[i].id === id ) {
        return this.state.clients[i];
      }
    }

    return {};
  }

  filter = ( id ) => {
    console.log( "filter", id );
    var _filtered = [];

    for( var i=0; i<this.state.items.length; i++ ) {
      if( this.state.items[i].client == id ) {
        _filtered.push( this.state.items[i] );
      }
    }

    this.setState({ items: _filtered });
  }

  dropAttachment = ( id ) => {
    let loader = this.refs.header.loader().loading( 'Borrando documento...' );

    this.http
      .deleteAttachment( this.state.viewOpen.id, id )
      .then( ( documents ) => {
        this.setState({ showDocuments: true, progress: true })
        this.setState({ progress: false, documents: documents });
               
        loader.finish();
      })
      .catch( this.errorHandler );
  }

  sendAttachment = ( id ) => {
    let loader = this.refs.header.loader().loading( 'Enviando documento por mail...' );

    this.http
      .sendAttachment( id )
      .then( ( documents ) => {
        alert( 'La poliza se envió por mail al titular.' );

        loader.finish();
      })
      .catch( this.errorHandler );
  }

  import = () => {
    this.setState({ importOpen: true });
  }
  
  render() {
    const items = this.state.items;
    const columns = [
      {
        key: 'column2',
        name: 'Empresa aseguradora',
        fieldName: 'company_name',
        minWidth: 100,
        maxWidth: 120,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column3',
        name: 'Cliente',
        fieldName: 'client_name',
        minWidth: 150,
        maxWidth: 250,
        isResizable:   false,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column4',
        name: 'Tipo de póliza',
        fieldName: 'type_name',
        minWidth: 130,
        maxWidth: 250,
        isResizable: true,
        isCollapsable: false,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column5',
        name: 'Número de póliza',
        fieldName: 'policy_number',
        minWidth: 120,
        maxWidth: 200,
        isResizable: true,
        isCollapsable: false,
        data: 'string',
        isPadded: true 
      },
      {
        key: 'column5',
        name: 'Inicio cobertura',
        fieldName: 'coverage_start',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: false,
        data: 'string',
        isPadded: true 
      },
      {
        key: 'column5',
        name: 'Fin cobertura',
        fieldName: 'coverage_end',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: false,
        data: 'string',
        isPadded: true 
      },
      {
        key: 'column7',
        name: 'Referencia',
        fieldName: 'reference',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: false,
        data: 'string',
        isPadded: true 
      }
    ]

    const menuItems = [
      {
        key: 'new',
        text: 'Nuevo',
        iconProps: {
          iconName: 'Add'
        },
        onClick: this.newItemHandler
      },
      {
        key: 'edit',
        text: 'Editar',
        iconProps: {
          iconName: 'Edit'
        },
        onClick: this.editItemHandler
      },
      {
        key: 'delete',
        text: 'Eliminar',
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.deleteItemHandler
      },
      {
        key: 'documents',
        text: 'Documentación',
        iconProps: {
          iconName: 'Document'
        },
        onClick: this.showDocuments
      }
    ];
    const menuFarItems = [
      {
        key: 'info',
        iconOnly: true,
        iconProps: {
          iconName: 'Info'
        }
      },
      {
        key: 'reload',
        text: 'Recargar',
        iconOnly: true,
        iconProps: {
          iconName: 'Refresh'
        },
        onClick: () => document.location.href = '/policies' 
      }
    ];
    const customItems = [
      {
        text: 'Exportar',
        iconProps: {
          iconName: 'ExcelLogo'
        },
        onClick: this.export
      },
      {
        text: 'Importar',
        iconProps: {
          iconName: 'CloudUpload'
        },
        onClick: this.import,
        disabled: ( this.props.match.params.id !== undefined )
      }
    ];

    const _client = this.getClientData( this.state.viewOpen.client );

    return (
      <Fabric>
        <Header title="Pólizas" ref="header" />

        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <CommandBar
                  items={ menuItems }
                  overflowItems={ customItems }
                  farItems={ menuFarItems }
                />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className={ "ms-Grid-col ms-sm12 " + ( this.state.viewOpen ? 'ms-lg9' : 'ms-lg12' ) } style={{ borderRight: '1px solid #ccc', paddingTop: 20 }}> 
              <DetailsList
                items={ items }
                columns={ columns }
                selectionMode={ SelectionMode.none }
                setKey="set"
                layoutMode={ DetailsListLayoutMode.justified } 
                onActiveItemChanged={ this.selectedItemChange } />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg3 ms-font-m" style={{ paddingTop: 20, display: this.state.viewOpen ? 'block' : 'none' }}>
              <div style={{ textAlign: 'right' }}><Icon iconName="ChromeClose" style={{ cursor: 'pointer' }} onClick={ () => { this.setState( { viewOpen: false, activeItem: {} } ); } }/></div>
              <h3 className="ms-font-xl">{ this.state.viewOpen.policy_number } ({ this.state.viewOpen.company_name })</h3>
              <hr />
              <p><strong className="ms-fontWeight-semibold">Compañia</strong>: { this.state.viewOpen.company_name }</p>
              <p><strong className="ms-fontWeight-semibold">Tipo</strong>: { this.state.viewOpen.type_name }</p>
              <p><strong className="ms-fontWeight-semibold">Póliza</strong>: { this.state.viewOpen.policy_number }</p>
              <p><strong className="ms-fontWeight-semibold">Inicio cobertura</strong>: { this.state.viewOpen.coverage_start }</p>
              <p><strong className="ms-fontWeight-semibold">Fin cobertura</strong>: { this.state.viewOpen.coverage_end }</p>
              <p>
                <strong>Cliente</strong><br/>
                { this.state.viewOpen.client_name }<br/>
                { _client.documentNumber }<br/>
                { _client.addressStreet } { _client.addressNumber }<br />
                { _client.addressZipcode } { _client.addressCity } { _client.addressState }<br/><br/>
                <em>Teléfono</em> { _client.phone }<br/>
                <em>Email</em> { _client.email }<br/>
              </p>
            </div>
          </div>
          <ImportPolicies isOpen={ this.state.importOpen } onDismiss={ () => { this.setState({ importOpen: false }) }} clients={this.state.clients} companies={ this.state.companies } policies={ this.state.items } types={ this.state.types } onComplete={ items => {
            document.location.href = '/policies';
          }} />
          <Panel
            isOpen={this.state.showDocuments}
            type={PanelType.smallFixedFar}
            onDismiss={ () => this.setState({ showDocuments: false }) }
            headerText={ 'Documentación - Póliza ' +  this.state.viewOpen.policy_number }>
            { this.state.progress && <ProgressIndicator description="Cargando documentos..." /> }
            { !this.state.progress && <h1 class="ms-font-xl">Listado de documentos</h1> }
            <ul>
            { this.state.documents.map( ( document ) => {
              let file = 'https://gosalbezehijos.com/entrypoint/insurance/attachments/' + document.id;
              let name = document.file.split('/');
              
              name = name[name.length -1];
              
              return ( 
                <DefaultButton text={name}
                  style={{ width: '100%', marginTop: 10 }}
                  menuProps={{
                    items: [
                      {
                        key: 'view',
                        iconProps: {
                          iconName: 'View'
                        },
                        text: 'Ver póliza',
                        onClick: () => window.open( file, '_blank' )
                      },
                      {
                        key: 'send',
                        iconProps: {
                          iconName: 'Share'
                        },
                        text: 'Enviar a: ' + _client.email,
                        onClick: () => this.sendAttachment( document.id )
                      },
                      {
                        key: 'delete',
                        iconProps: {
                          iconName: 'Delete'
                        },
                        text: 'Eliminar adjunto',
                        onClick: () => this.dropAttachment( document.id )
                      }
                    ]
                  }} />
              );
            } ) }
            </ul>
            <div style={{ marginTop: 10, marginBottom: 10 }}>&nbsp;</div>
            <XHRUploader url={ "https://gosalbezehijos.com/entrypoint/insurance/attachments?policy=" + this.state.viewOpen.id } dropzoneLabel='Arrastre o seleccione el archivo que se desea adjuntar' auto />
          </Panel>
          <Panel
            isOpen={this.state.showPanel}
            type={PanelType.smallFluid}
            onDismiss={ () => this.setState({ showPanel: false }) }
            headerText="Cliente"
            onRenderFooter={ () => {
              return (
                <div className="ms-textAlignCenter">
                  <PrimaryButton onClick={ this.saveItemHandler } style={{ marginRight: 10 }}>Guardar</PrimaryButton>
                  <DefaultButton onClick={ () => this.setState({ showPanel: false }) } >Cancelar</DefaultButton>
                </div>

              )
            }}>
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <Dropdown
                      placeHolder="Seleccione una compañia"
                      label="Compañia aseguradora"
                      name="company"
                      onChanged={ ( item ) => {
                        this.updateItem( item.id, 'company' );
                      } }
                      defaultSelectedKey={ this.state.activeItem.company }
                      options={ this.state.companies } />
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <Dropdown
                        placeHolder="Seleccione un tipo de póliza"
                        label="Tipo de póliza"
                        name="type"
                        onChanged={ ( item ) => {
                          this.updateItem( item.id, 'type' );
                        } }
                        defaultSelectedKey={ this.state.activeItem.type }
                        options={ this.state.types } />
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <Dropdown
                        placeHolder="Seleccione un cliente"
                        label="Cliente"
                        name="client"
                        onChanged={ ( item ) => {
                          this.updateItem( item.id, 'client' );
                        }}
                        defaultSelectedKey={ this.state.activeItem.client }
                        options={ this.state.clients } />
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="policy_number" label="Número de póliza" value={ this.state.activeItem.policy_number } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="coverage_start" label="Inicio de cobertura" value={ this.state.activeItem.coverage_start } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField name="coverage_end" label="Fin de cobertura" value={ this.state.activeItem.coverage_end } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg12">
                    <TextField name="reference" label="Referencia de la póliza" value={ this.state.activeItem.reference } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
              </div>
          </Panel>
          
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/Policies.jsx